import { ACCEPT, ERROR_FETCH_TOS, START_FETCH_TOS, SUCCESS_FETCH_TOS } from 'login-actions/actionTypes';

const initialState = {
  fetching: false,
  success: false,
  error: null,
  content: null,
  acceptedAt: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_FETCH_TOS:
      return { ...state, success: true, error: null, fetching: false, content: action.payload };
    case ERROR_FETCH_TOS:
      return { ...state, success: false, error: action.payload, fetching: false, content: null };
    case START_FETCH_TOS:
      return { ...state, success: false, error: null, fetching: true, content: null };
    case ACCEPT:
      return { ...state, acceptedAt: Date.now() };
    default:
      return state;
  }
};
